export const environment = {
  production: true,
  API: 'https://homolog.api.xrleiloes.com.br',
  UPLOADS_DIR: 'https://homolog.api.xrleiloes.com.br/uploads',
  SOCKET_URL: 'https://homolog.panel.xrleiloes.com.br/',
};
